import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';
import { IDiversionsWaybill } from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-diversions-review-details',
  templateUrl: './diversions-review-details.component.html',
  styleUrls: ['./diversions-review-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiversionsReviewDetailsComponent {
  @Input() loading!: boolean;
  @Input() configs!: IGridConfigurations;
  @Input() data: Array<IDiversionsWaybill> = [];
  @Output() refresh = new EventEmitter<void>();

  constructor() { }

  /**
   * Handle Refresh
   *
   * @summary Emits refresh action to refresh the grid
   * @returns void
   */
  handleRefresh(): void {
    this.refresh.emit();
  }
}
